const GET_PURCHASE_ORDER_HISTORY = "GET_PURCHASE_ORDER_HISTORY" 
const SET_PURCHASE_ORDER_HISTORY = "SET_PURCHASE_ORDER_HISTORY"

export {
    GET_PURCHASE_ORDER_HISTORY,
    SET_PURCHASE_ORDER_HISTORY,
}